// @ts-check

/** @file Defines the local TaskType shell and associations. */

import TaskTypeBase from "../model-bases/task-type.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Flattened task-type row in the local application replica. */
const TaskTypeModel = projectReplicaModel(TaskTypeBase)

export default TaskTypeModel

TaskTypeModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskTypeModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskTypeModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
TaskTypeModel.hasMany("tasks")
